// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton_backButton__hBNQM","icon":"BackButton_icon__YdcXI"};